exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#view.intake-view {\n  margin-left: 0px; }\n\n.intake-form-display {\n  display: flex;\n  justify-content: space-between;\n  min-height: calc(100vh - 62px);\n  flex-direction: column;\n  margin: -20px; }\n\n.intake-form-actions-display {\n  margin: auto 0 0; }\n  .intake-form-actions-display .ssg-forms-btn {\n    font-family: 'graphik', sans-serif;\n    font-weight: normal; }\n\n@media (max-width: 768px) {\n  .intake-form-display {\n    min-height: calc(100vh - 42px); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/intake/intake-form.scss
// module id = 1456
// module chunks = 0